export default "__VITE_ASSET__DSxD4Inn__"